import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categoryList: [],
  categoryFormList: [],
  categoryDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};
const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchCategoryList(state, action) {
      state.categoryList = action.payload;
      state.loading = false;
    },
    fetchCategoryFormList(state, action) {
      state.categoryFormList = action.payload;
      state.loading = false;
    },
    fetchCategoryDetail(state, action) {
      state.categoryDetail = action.payload;
      state.loading = false;
    },
  },
});

export const categoryActions = categorySlice.actions;

export default categorySlice.reducer;
